// Web Push API — wraps /push/* (ported from notifications.js).
// vapidKey() returns {public_key}; subscribe sends the PushSubscription JSON.
// unsubscribe() may pass this device's subscription — the backend then removes
// only its entry, keeping other browsers/Android subscribed (Redmine 4460).
import { api } from './client'

export type AndroidPushSubscription = { platform: 'android'; token: string }

export const pushApi = {
  vapidKey: () => api.get<{ public_key: string }>('/push/vapid-key', { auth: false }),
  subscribe: (subscription: PushSubscriptionJSON | AndroidPushSubscription) =>
    api.post('/push/subscribe', { subscription }),
  unsubscribeDevice: (
    subscription: PushSubscriptionJSON | AndroidPushSubscription,
    accessToken?: string,
  ) => accessToken
    ? api.post('/push/unsubscribe', { subscription }, {
        auth: false,
        headers: { Authorization: `Bearer ${accessToken}` },
      })
    : api.post('/push/unsubscribe', { subscription }),
}
